

































import { Vue, Component, Emit, Prop } from "vue-property-decorator";
import { ICustomStylingClass } from "./types/custom.t";
import CustomContainer from "./CustomContainer.vue";
import CustomText from "./CustomText.vue";
import CustomInput from "./Form/CustomInput.vue";


@Component({
  components: {
    CustomContainer,
    CustomText,
    CustomInput
  },
})
export default class ZoomControl extends Vue {

  @Prop()
  zoomValue!: string;

  @Prop()
  min!: number;

  @Prop()
  max!: number;

  @Prop()
  step!: number;

  @Prop()
  controlLeftText!: string;

  @Prop()
  controlRightText!: string;

  @Prop({ default: true })
  showControlLeft!: boolean;

  @Prop({ default: true })
  showControlRight!: boolean;

  @Prop({ default: true })
  customsClasses!: ICustomStylingClass[];

  @Emit('onChange')
  onChange() {}

  @Emit('zoomIn')
  zoomIn() {}

  @Emit('zoomOut')
  zoomOut() {}
}
